














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
})
export default class VideoSection extends Vue {
  @Prop({ required: false })
  public title!: string;

  @Prop({ required: true })
  public videoMp4!: string;

  @Prop({ required: false })
  public videoWebm!: string | null;

  public videoHtml: string = '';
  public videoPlaying = false;

  public mounted() {
    this.videoHtml = `
      <video id="video-section" muted controls loop playsinline>
        ${ this.videoWebm ? `<source src="${this.videoWebm}" type="video/webm">` : '' }
        <source src="${this.videoMp4}" type="video/mp4">
      </video>
    `;
    this.watchViewport();
  }

  public showVideo() {
    if (this.videoPlaying) { return; }
    if (!this.isVideoInViewport()) { return; }

    const videoEl = document.getElementById('video-section');
    if (!videoEl) { return; }

    this.videoPlaying = true;
    (videoEl as any).play();
  }

  public watchViewport() {
    if (window.addEventListener) {
      addEventListener('DOMContentLoaded', this.showVideo, false);
      addEventListener('load', this.showVideo, false);
      addEventListener('scroll', this.showVideo, false);
      addEventListener('resize', this.showVideo, false);
    } else if ((window as any).attachEvent)  {
      (window as any).attachEvent('onDOMContentLoaded', this.showVideo);
      (window as any).attachEvent('onload', this.showVideo);
      (window as any).attachEvent('onscroll', this.showVideo);
      (window as any).attachEvent('onresize', this.showVideo);
    }
  }

  public isVideoInViewport() {
    const el = this.$refs['video-element'] as any;
    if (!el || !el.getBoundingClientRect) { return false; }

    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}
